/**
 * "$8,097.64", "$8,097", "-$0.64". Cents appear only when the amount has
 * them, so whole-dollar estimates stay compact next to invoice-derived
 * actuals that carry cents. Rounds to the cent first to hide float noise.
 */
export function formatMoney(n: number | string | null | undefined): string {
  const cents = Math.round((Number(n) || 0) * 100);
  const abs = Math.abs(cents) / 100;
  const text = abs.toLocaleString("en-US", {
    minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return `${cents < 0 ? "-" : ""}$${text}`;
}

/** Parse what a user typed into a money field: "$8,097.64" → 8097.64; junk → 0. */
export function parseMoney(text: string): number {
  const n = parseFloat(String(text).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(n) ? Math.round(n * 100) / 100 : 0;
}
